import "./App.scss";
import { Component } from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { judgmentTerminal } from "./components/Terminal";
import { Home as Home_PC } from "./views/PC/Home";
import {CBU as CBU_PC} from "./views/PC/CBU";
import {EBU as EBU_PC} from "./views/PC/EBU";
import Home_Mobile from "./views/Mobile/Home";
import CBU_Mobile from "./views/Mobile/CBU";
import EBU_Mobile from "./views/Mobile/EBU";
class App extends Component {
  state = {
    isMobile: false,
  };
  componentDidMount() {
    // console.log("数据加载");
    this.setState({
      isMobile: judgmentTerminal(),
    });
  }
  render() {
    const { isMobile } = this.state;
    // console.log(isMobile);
    const Page = isMobile ? Home_Mobile : Home_PC;
    const PageCBU = isMobile ? CBU_Mobile : CBU_PC;
    const PageEBU = isMobile ? EBU_Mobile : EBU_PC;
    return (
      // <Router basename="/yoocar-web">
      <Router>
        {/* <div className="loader_container">
          <div className="loader">
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__ball"></div>
          </div>
        </div> */}
        <Switch>
          <Route exact path="/" component={Page} />
          <Route exact path="/CBU" component={PageCBU} />
          <Route exact path="/EBU" component={PageEBU} />
        </Switch>
      </Router>
    );
  }
}

export default App;
